import { FONT_FAMILY } from 'fonts';

import { typography } from '../typography';

import type { TypographyOptions } from '@mui/material/styles/createTypography';

/**
 * The Design System 2.0 typography (HNS-260): the Figma library's typeface, and nothing else.
 *
 * The FACE changes here; the METRICS do not. HNS-257 already adopted the Figma type scale for the
 * DS 2.0 component layer, and the library also specs Body 16/26, Display 24/34 and Display Large
 * 40/50 against this app's 16/24 — moving the MUI variants onto those is deliberately a separate
 * change, because it alters line heights everywhere at once and the tightly-constrained screens
 * (live room controls, wizard steps, chart axis labels) are where that goes wrong.
 *
 * Spreading `typography` rather than restating it is what keeps that promise checkable: the test
 * beside this file asserts `fontFamily` is the only key that differs.
 *
 * MUI resolves this to a `font-family` on every Typography variant, and `CssBaseline` writes it to
 * `body` — which is how one object reaches nearly every rendered string with no call-site changes.
 * The rest is CSS, in `fonts/fonts.css` and the `--font-sans` token; see `VISUAL_REFRESH_CLASS`.
 */
export const refreshTypography: TypographyOptions = {
  ...typography,
  fontFamily: FONT_FAMILY.googleSansFlex,
};
